export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-300">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 no-underline mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-white text-base">
                <i className="ri-heart-fill"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-100">情侣影院</span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed">
              情侣影院是国内领先的情侣追剧平台，专注收录电视剧全集和最新电视剧。国产剧全集、韩剧全集高清免费在线看，为每一对情侣提供最温馨的追剧体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-100 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#hero" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</a>
              <a href="#ranking" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">热播榜单</a>
              <a href="#cards" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">精选推荐</a>
              <a href="#carousel" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">专题聚焦</a>
              <a href="#index" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">剧集分类</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-100 mb-4">剧集类型</h4>
            <div className="space-y-2.5">
              <a href="#index" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">国产剧全集</a>
              <a href="#index" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">韩剧全集</a>
              <a href="#index" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">古装仙侠剧</a>
              <a href="#index" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">悬疑刑侦剧</a>
              <a href="#index" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">甜宠恋爱剧</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              情侣影院正在持续拓展内容合作，欢迎优质影视内容方与我们联系。更多合作伙伴信息即将上线。
            </p>
            <div className="mt-4">
              <a href="#contact" className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors">
                <i className="ri-mail-line"></i>
                联系投稿
              </a>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024 情侣影院 qinglvcinema.com — 电视剧全集·最新电视剧免费在线看
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#faq" className="hover:text-primary-400 transition-colors">常见问题</a>
            <a href="#contact" className="hover:text-primary-400 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}